const REFERENCE_ID = '__app-reference-element';

export const fixScreen = (): void => {
  const height = `${window.innerHeight}px`;
  if (document.documentElement) {
    document.documentElement.style.height = height;
  }
  if (document.body) {
    document.body.style.height = height;
  }
};

const getElement = (): HTMLElement => {
  const e =
    document.getElementById(REFERENCE_ID) || document.createElement('div');
  e.setAttribute('id', REFERENCE_ID);
  e.setAttribute(
    'style',
    'height: 1mm; width: 1mm; position: absolute; left: -100%; top: -100%',
  );
  if (document.body && !document.body.contains(e)) {
    document.body.appendChild(e);
  }
  return e;
};

export const getMmInPx = (): number => getElement().offsetHeight;
export const isMobile = (): boolean => window.innerWidth <= 640;
